/*
 * ELTANE — theme toggle
 *
 * The initial theme is resolved by a small blocking script in
 * layout/theme.liquid so the page never paints the wrong theme first.
 * This file only handles the click, the persisted choice, and keeping
 * the button's accessible state in sync.
 */
(function () {
  var STORAGE_KEY = 'eltane-theme';
  var root = document.documentElement;

  function currentTheme() {
    return root.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function setMeta(name, value) {
    var el = document.querySelector('meta[name="' + name + '"]');
    if (el) el.setAttribute('content', value);
  }

  function syncButtons(theme) {
    var buttons = document.querySelectorAll('.eltane-theme-toggle');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var label = theme === 'light' ? btn.getAttribute('data-label-dark') : btn.getAttribute('data-label-light');
      btn.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
      if (label) btn.setAttribute('aria-label', label);
    }
  }

  function apply(theme, persist) {
    root.setAttribute('data-theme', theme);
    setMeta('color-scheme', theme);
    setMeta('theme-color', theme === 'light' ? '#edf7f7' : '#000000');
    syncButtons(theme);

    if (persist) {
      try {
        localStorage.setItem(STORAGE_KEY, theme);
      } catch (e) {
        /* private browsing / storage disabled — the toggle still works for this page */
      }
    }
  }

  function toggle() {
    var next = currentTheme() === 'light' ? 'dark' : 'light';

    // Flag the colour-only transition, then clear it so the flag never
    // interferes with normal scroll/hover transitions.
    root.setAttribute('data-eltane-theme-switching', '');
    apply(next, true);
    window.setTimeout(function () {
      root.removeAttribute('data-eltane-theme-switching');
    }, 300);
  }

  function init() {
    syncButtons(currentTheme());
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('.eltane-theme-toggle');
      if (btn) {
        event.preventDefault();
        toggle();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
